export default "__VITE_ASSET__bdc14f7d__"